// Exports:
export default ref => ref.current?.scrollIntoView({ behavior: 'instant' })
